export class EventVO {
  order() {

  }
}
